import { makeStyles } from '@mui/styles';

export const useResultItemRowStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    textAlign: 'left'
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  icon: {
    color: theme.palette.text.secondary,
    marginTop: '2px',
    flexShrink: 0
  },
  text: {
    minWidth: 0,
    flex: 1
  },
  primaryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap'
  },
  primary: {
    fontWeight: 600,
    wordBreak: 'break-word'
  },
  tag: {
    flexShrink: 0,
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1.5,
    padding: '0 6px',
    borderRadius: '4px',
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    whiteSpace: 'nowrap'
  },
  secondary: {
    display: 'block',
    wordBreak: 'break-word'
  },
  trailing: {
    flexShrink: 0,
    width: '90px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    marginTop: '2px'
  }
}));
